import './Home.css'
import Login from './Login';
import React from "react";
import logo from '../../assets/big-logo.png'



const Home = () => {

  return (
    <>
     <div className="home-container">
        {/* Your logo */}
        <div className='logo-container'>
        <img src={logo} alt="Your Logo" className="logo" />
        </div>
        {/* Welcome message */}
        <div className='welcome-container'><h3>מערכת לניהול רשיונות תוכנה </h3></div>


        {/* Login component */}
        <Login />
      </div>

    </>
  );
};

export default Home;